// MUI Components 
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ChecklistIcon from '@mui/icons-material/Checklist';
import { Link } from "react-router-dom";


const Sidebar = () => {
  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 64px)', maxWidth: 220, boxShadow: '3px 3px 3px lightgray' }}>
      <nav aria-label="main mailbox folders">
        <List>
          <ListItem >
            <ListItemButton component={Link} to={'/screen'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Screens" />
            </ListItemButton>
          </ListItem>
          <ListItem >
            <ListItemButton component={Link} to={'/spaces'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Spaces" />
            </ListItemButton>
          </ListItem>
          <ListItem >
            <ListItemButton component={Link} to={'/locations'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Locations" />
            </ListItemButton>
          </ListItem>
          <ListItem >
            <ListItemButton component={Link} to={'/maps'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Maps" />
            </ListItemButton>
          </ListItem>
          <ListItem >
            <ListItemButton component={Link} to={'/models'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Models" />
            </ListItemButton>
          </ListItem>
          <ListItem >
            <ListItemButton component={Link} to={'/feedback-question'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Feedback Questions" />
            </ListItemButton>
          </ListItem>
          <ListItem >
            <ListItemButton component={Link} to={'/labels'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Labels" />
            </ListItemButton>
          </ListItem>
          <ListItem >
            <ListItemButton component={Link} to={'/pages'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Info Pages" />
            </ListItemButton>
          </ListItem>
          <ListItem >
            <ListItemButton component={Link} to={'/selfie-mask'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Selfie Masks" />
            </ListItemButton>
          </ListItem>
          <ListItem >
            <ListItemButton component={Link} to={'/treasure'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Treasure Hunt" />
            </ListItemButton>
          </ListItem>
          {/* <ListItem >
            <ListItemButton component={Link}  to={'/env-sounds'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Enviroment Sounds"/>
            </ListItemButton>
          </ListItem> */}
          <ListItem >
            <ListItemButton component={Link} to={'/user'}>
              <ListItemIcon>
                <ChecklistIcon />
              </ListItemIcon>
              <ListItemText primary="Users" />
            </ListItemButton>
          </ListItem>
        </List>
      </nav>
    </Box>
  );
}
export default Sidebar;